'use client'

import {createCalendarPeriodPicker, type CalendarPeriodOverlayProps} from '@fitro/customer-ui/CalendarPeriodPicker'
import {SelectionDropdown} from './Dropdown/Dropdown'

const CalendarPeriodOverlay = ({title, closeText, ...props}: CalendarPeriodOverlayProps) => (
    <SelectionDropdown {...props} modal contentRole="dialog" contentAriaLabel={title} cancelText={closeText}/>
)

export const CalendarPeriodPicker = createCalendarPeriodPicker({Overlay: CalendarPeriodOverlay})

// The website embed's iframe grows to its content, so a bottom sheet would open below the visible part of the page.
const InlineCalendarPeriodOverlay = ({title, closeText: _closeText, ...props}: CalendarPeriodOverlayProps) => (
    <SelectionDropdown {...props} contentRole="dialog" contentAriaLabel={title}/>
)

export const InlineCalendarPeriodPicker = createCalendarPeriodPicker({Overlay: InlineCalendarPeriodOverlay})
